import "../css/table.css";
import "../css/allApplications.css";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LOAD_ALLAPPLICATIONS_REQUEST } from "../reducers/adminBusiness";
import {
  LOAD_ALLUSER_REQUEST,
  LOAD_BUSINESS_REQUEST,
} from "../reducers/adminUser";
const AllApplications = ({ onSelectDetail }) => {
  const dispatch = useDispatch();
  const { allApplications } = useSelector((state) => state.adminBusiness);
  const { userBusinesses, allUsers } = useSelector((state) => state.adminUser);
  const previousComponent = "구인신청서 목록";
  useEffect(() => {
    // 신청서 목록만 불러오면 회사명·아이디·지역을 채울 수 없습니다.
    // 그 정보는 회원 데이터(allUsers, userBusinesses)에 들어있는데,
    // 예전엔 이 화면에서 요청을 안 해서 "전체회원" 메뉴를 먼저 들르지 않으면
    // 목록이 통째로 비어 보였습니다. 여기서 직접 함께 불러옵니다.
    dispatch({
      type: LOAD_ALLAPPLICATIONS_REQUEST,
    });
    dispatch({
      type: LOAD_ALLUSER_REQUEST,
    });
    dispatch({
      type: LOAD_BUSINESS_REQUEST,
    });
  }, []);

  return (
    <div className="section allApplications">
      <div className="table_container">
        <div className="row row_head">
          <p>No</p>
          <p>아이디</p>
          <p>회사명</p>
          <p>신청서 제목</p>
          <p>지역</p>
          <p>등록일</p>
        </div>
        {allApplications &&
          allUsers &&
          userBusinesses &&
          allApplications.map((allApplication, index) => {
            const user = allUsers.find(
              (user) => user.id === allApplication.BusinessId
            );
            const userDetail = userBusinesses.find(
              (user) => user.BusinessId === allApplication.BusinessId
            );
            // 주소가 아직 등록되지 않은 기업이 하나라도 있으면 예전 코드는
            // 여기서 멈춰버려서 목록 전체가 안 나왔습니다. 값이 없으면
            // 빈칸으로 두고 나머지 줄은 정상적으로 보여줍니다.
            const array = userDetail?.business_member_jibunAddress
              ? userDetail.business_member_jibunAddress.split(" ")
              : [];
            const businessId = allApplication.BusinessId;
            return (
              <div
                className={
                  index % 2 === 0 ? "content_row row" : "content_row row even"
                }
                onClick={(e) =>
                  onSelectDetail("공고내용", {
                    businessId,
                    // 한 기업이 공고를 여러 건 낼 수 있어서, 기업 번호만으로는
                    // 어느 공고를 클릭했는지 알 수 없었습니다. 공고 번호도
                    // 함께 넘겨서 정확히 그 공고를 펼치도록 했습니다.
                    applicationId: allApplication.id,
                    previousComponent,
                  })
                }
                key={index}
                style={{ cursor: "pointer" }}
              >
                <p>{allApplication.id}</p>
                <p>{user?.user_member_id}</p>
                <p>{userDetail?.business_member_companyName}</p>
                {/* 예전엔 business_application_title이라는, 실제로는 없는
                    필드를 읽고 있어서 제목 칸이 항상 비어 있었습니다.
                    구인신청서에서 "채용 제목"으로 저장되는 실제 필드는
                    business_application_name입니다. */}
                <p>{allApplication.business_application_name}</p>
                <p>{array[0]}</p>
                <p>{dayjs(allApplication.createdAt).format("YYYY.MM.DD")}</p>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default AllApplications;
